import { STUDENGT_LIST,USER_PROFILE } from '../apiEndpoint';
import { studentAxios ,mainAxios} from '../http/http'

export default function studentList(email, role,studentEmail = '', track = '', status = '') {
  return studentAxios.get(STUDENGT_LIST+"?user_email="+email+'&role='+role+'&learner_email='+studentEmail+'&learning_path_name='+track+'&learner_status='+status,{ 
  headers: { "ApiKey": process.env.REACT_APP_STUDENT_GO_APIKEY}
}
    );
  };
